import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Route, Redirect, Switch, useLocation } from "react-router-dom";
import Box from "@material-ui/core/Box";
import { Divider, IconButton } from "@material-ui/core";
import ProfileTab from "./ProfileTab";
import AuthTab from "./AuthTab";
import { setUser } from "../../../store/actions/auth";
import StyledDrawer from "../StyledDrawer";
import UnsavedChangesDialog from "../../dialogs/UnsavedChangesDialog";
import history from "../../../utils/history";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(theme => ({
  tabsWrapper: {
    padding: theme.spacing(0, 1),
    marginBottom: -1,
    marginTop: theme.spacing(3),
    minHeight: theme.spacing(5)
  },
  tabItem: {
    minWidth: "0",
    textTransform: "none",
    fontSize: "0.875rem",
    padding: theme.spacing(1, 0, 1.75),
    margin: theme.spacing(0, 2),
    lineHeight: "1rem",
    minHeight: theme.spacing(5),
    color: theme.palette.secondary.main
  },
  primary: {
    color: theme.palette.text.primary + "!important"
  },
  title: {
    fontSize: "1.25rem",
    lineHeight: "1.4375rem",
    fontWeight: 500
  },
  iconButton: {
    marginLeft: "-0.5rem",
    marginRight: theme.spacing(2),
    "& svg": {
      width: theme.spacing(3),
      height: theme.spacing(3)
    }
  },
  divider: {
    backgroundColor: "#DDD"
  }
}));

function AccountDialog({
  open,
  handleClose,
  drawerExpanded,
  userData,
  setUser,
  saveDisabled,
  setSaveDisabled
}) {
  const classes = useStyles();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const [changesDialog, setChangesDialog] = useState({
    visible: false,
    action: () => {}
  });

  // Change tab
  const handleChange = (event, newValue) => {
    if (saveDisabled) {
      history.replace(newValue);
    } else {
      setChangesDialog({
        visible: true,
        action: () => history.replace(newValue)
      });
    }
  };

  useEffect(() => {
    setSaveDisabled(true);
  }, [open, setSaveDisabled]);

  const warnClose = saveDisabled
    ? handleClose
    : () => setChangesDialog({ visible: true, action: handleClose });

  return (
    <StyledDrawer open={open} handleClose={warnClose} loading={loading}>
      <Box
        className={classes.accountHeader}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={3}
        py={2.5}
      >
        <Box alignSelf="center" alignItems="center" display="flex" pr={2}>
          <IconButton onClick={warnClose} className={classes.iconButton}>
            <CloseIcon />
          </IconButton>
          <Typography className={classes.title} variant="h5" noWrap>
            Account
          </Typography>
        </Box>
      </Box>

      <Tabs
        value={location.pathname}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        className={classes.tabsWrapper}
      >
        <Tab
          label="Profile"
          value="/account/profile"
          to="/account/profile"
          classes={{ root: classes.tabItem, selected: classes.primary }}
        />
        <Tab
          label="Authentication"
          value="/account/authentication"
          to="/account/authentication"
          classes={{ root: classes.tabItem, selected: classes.primary }}
        />
      </Tabs>
      <Divider className={classes.divider} />
      <Box pl={3} pr={5} flexGrow="1" flexShrink="1" overflow="auto">
        <Switch>
          <Route path="/account/profile">
            <ProfileTab
              userData={userData}
              drawerExpanded={drawerExpanded}
              handleClose={warnClose}
              setLoading={setLoading}
              setUser={setUser}
              saveDisabled={saveDisabled}
              setSaveDisabled={setSaveDisabled}
            />
          </Route>
          <Route path="/account/authentication">
            <AuthTab
              handleClose={warnClose}
              setLoading={setLoading}
              userData={userData}
              saveDisabled={saveDisabled}
              setSaveDisabled={setSaveDisabled}
            />
          </Route>
          <Redirect to="/account/profile" />
        </Switch>
      </Box>

      <UnsavedChangesDialog
        open={changesDialog.visible}
        handleClose={() => {
          setChangesDialog({ visible: false, action: () => {} });
        }}
        action={() => {
          changesDialog.action();
          setSaveDisabled(true);
        }}
      />
    </StyledDrawer>
  );
}

const mapStateToProps = state => ({
  userData: state.auth.userData
});

export default connect(mapStateToProps, { setUser })(AccountDialog);
